import moment from "moment";
import { initialState } from "./../initialState";
import * as Assignment from "./assignmentActions";

export const assignmentReducer = (state = initialState.assignments, action) => {
    switch (action.type) {
        case Assignment.REQUEST_ASSIGNMENTS_SUCCEEDED:
            return Object.assign({}, state, {
                assignments: [...action.assignments],
            });

        case Assignment.UPDATE_ASSIGNMENT:
            const existingAssignments = [...state.assignments];
            const existingAssignmentIndex = existingAssignments.findIndex(
                (assignment) => assignment.workOrderNumber === action.assignment.workOrderNumber,
            );

            // remove the existing assignment before adding the new one
            if (existingAssignmentIndex !== -1) {
                existingAssignments.splice(existingAssignmentIndex, 1);
            }

            // if assignment is assigned to a labourer add the new assignment to the list
            // of assignments
            if (action.assignment.resourceAssignedTo) {
                existingAssignments.push({
                    ...action.assignment,
                });
            }

            // return the new assignment state
            return {
                ...state,
                assignments: existingAssignments,
            };

        case Assignment.REQUEST_ASSIGN_TASK:
            return Object.assign({}, state, {
                assignTaskRequest: action.assignTaskRequest,
            });

        case Assignment.SHOW_ASSIGNMENT_OVERLAPS:
            return Object.assign({}, state, {
                overlaps: [...action.overlaps],
            });

        case Assignment.CLEAR_ASSIGNMENT_OVERLAPS:
            return Object.assign({}, state, {
                assignTaskRequest: null,
                overlaps: [],
            });

        default:
            return state;
    }
};
